import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await register(name, email, password);
      toast.success(`Welcome, ${data.name}`);
      nav("/");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-app px-6 py-16 grid place-items-center">
      <div className="w-full max-w-md bg-white rounded-2xl border border-gray-100 p-8">
        <h1 className="font-heading text-3xl font-bold text-[#1A1A1A]">Create your account</h1>
        <p className="text-[#595959] mt-1 text-sm">Track orders and enjoy faster checkout.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="name">Name</Label>
            <Input data-testid="register-name" id="name" required value={name}
                   onChange={(e) => setName(e.target.value)} className="mt-1 rounded-lg"/>
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input data-testid="register-email" id="email" type="email" required value={email}
                   onChange={(e) => setEmail(e.target.value)} className="mt-1 rounded-lg"/>
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input data-testid="register-password" id="password" type="password" required minLength={6} value={password}
                   onChange={(e) => setPassword(e.target.value)} className="mt-1 rounded-lg"/>
          </div>
          <Button data-testid="register-submit" type="submit" disabled={loading}
                  className="w-full rounded-full bg-[#638971] hover:bg-[#4F705B] text-white h-11">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>
        <p className="mt-5 text-sm text-[#595959] text-center">
          Have an account? <Link data-testid="go-to-login" to="/login" className="text-[#638971] font-semibold">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
